/**
 * Utility function to translate form configurations
 * @param {Object} formConfig - The form configuration object
 * @param {Function} t - Translation function
 * @returns {Object} Translated form configuration
 */
export const translateFormConfig = (formConfig, t) => {
  if (!formConfig || !t) {
    return formConfig;
  }

  const formId = formConfig.form_id;
  
  // Translate form title
  const titleKey = `forms.${formId}.title`;
  const translatedTitle = t(titleKey);
  const formTitle = translatedTitle !== titleKey ? translatedTitle : formConfig.form_title;
  
  // Translate form description
  const descriptionKey = `forms.${formId}.description`;
  const translatedDescription = t(descriptionKey);
  const formDescription = translatedDescription !== descriptionKey ? translatedDescription : formConfig.form_description;
  
  // Translate input fields
  const translatedFields = formConfig.input_fields.map(field => {
    const fieldId = field.field_id;
    
    // Translate label
    const labelKey = `forms.${formId}.fields.${fieldId}.label`;
    const translatedLabel = t(labelKey);
    const fieldLabel = translatedLabel !== labelKey ? translatedLabel : field.label;
    
    // Translate placeholder if it exists
    let fieldPlaceholder = field.placeholder;
    if (field.placeholder) {
      const placeholderKey = `forms.${formId}.fields.${fieldId}.placeholder`;
      const translatedPlaceholder = t(placeholderKey);
      if (translatedPlaceholder !== placeholderKey) {
        fieldPlaceholder = translatedPlaceholder;
      }
    }
    
    // Translate options if they exist
    let fieldOptions = field.options;
    if (field.options && Array.isArray(field.options)) {
      fieldOptions = field.options.map(option => {
        // Sanitize option key - replace special characters with underscores
        const sanitizedOption = option.replace(/[^a-zA-Z0-9]/g, '_').replace(/_+/g, '_');
        const optionKey = `forms.${formId}.fields.${fieldId}.options.${sanitizedOption}`;
        const translatedOption = t(optionKey);
        return translatedOption !== optionKey ? translatedOption : option;
      });
    }
    
    return {
      ...field,
      label: fieldLabel,
      placeholder: fieldPlaceholder,
      options: fieldOptions
    };
  });
  
  return {
    ...formConfig,
    form_title: formTitle,
    form_description: formDescription,
    input_fields: translatedFields
  };
};

